import { enqueueSnackbarNotification } from '@slices/snackbar-notification';

import { ERROR_CODE, ERROR_TEXTS_BY_CODE } from '@config/errors';

import { BaseNetError } from '@errors/base-net-error';

import { AccountHandleError } from './types';

export const accountHandleError: AccountHandleError =
  (payload) => (dispatch) => {
    const { error } = payload;

    if (!(error instanceof BaseNetError)) {
      return dispatch(
        enqueueSnackbarNotification({
          message: ERROR_TEXTS_BY_CODE[ERROR_CODE.UNEXPECTED_ERROR],
          options: { variant: 'error' },
        })
      );
    }

    if (error.status === ERROR_CODE.INCORRECT_USERNAME_OR_PASSWORD) {
      dispatch(
        enqueueSnackbarNotification({
          message:
            ERROR_TEXTS_BY_CODE[ERROR_CODE.INCORRECT_USERNAME_OR_PASSWORD],
          options: { variant: 'warning' },
        })
      );

      return;
    }

    if (error.status === ERROR_CODE.NOT_FOUND) {
      dispatch(
        enqueueSnackbarNotification({
          message: ERROR_TEXTS_BY_CODE[ERROR_CODE.NOT_FOUND],
          options: { variant: 'error' },
        })
      );

      return;
    }

    dispatch(
      enqueueSnackbarNotification({
        message: ERROR_TEXTS_BY_CODE[ERROR_CODE.UNEXPECTED_ERROR],
        options: { variant: 'error' },
      })
    );
  };
